module.exports = __webpack_public_path__ + "static/img/shi.0fb7090f.png";